import React from "react";

import { SearchingWrangler } from "./SearchingWrangler";

export enum GifType {
  Searching = "searching",
}

interface WranglerProps {
  variant: GifType;
  size?: "sm" | "md" | "lg";
  className?: string;
  hideText?: boolean;
}

export const Wrangler: React.FC<WranglerProps> = ({ variant, size, className, hideText }) => {
  switch (variant) {
    case GifType.Searching:
      return <SearchingWrangler size={size} className={className} hideText={hideText} />;
    default:
      return <SearchingWrangler size={size} className={className} hideText={hideText} />;
  }
};
